import React, { useState } from 'react';
import styled from 'styled-components';
import moment from 'moment-timezone';
import 'moment/locale/ko';
import { useParams } from 'react-router-dom';
import OrderController, {
  KnockOrderLandingItemType,
  OrderChildType,
} from '../controller/OrderController';
import LangSelectBox from './LangSelectBox';
import RatingContent from './RatingContent';
import { langText } from '../recoil/lang';
import CustomerServiceModal from '../components/modal/CustomerServiceModal';
import {
  getProductName,
  getOptionName,
  getOptionTypeName,
  getPickupName,
  getCancelDescription,
} from '../utils/util';

interface PropsType {
  orderData: any;
  orderStatus: string;
  lang: number;
  setLang: any;
  refresh: any;
  setVisibleCancel: any;
}
interface OrderStatusTextEntry {
  statusText: string;
  subText: string;
  buttonText: string;
  icon: string;
  progressWidth: string;
}
const OrderQrStaus = ({
  orderData,
  orderStatus,
  lang,
  setLang,
  refresh,
  setVisibleCancel,
}: PropsType) => {
  const [visibleCumtomer, setVisibleCumtomer] = useState<boolean>(false);
  const orderListData: OrderChildType = orderData?.child[0];
  const orderListDetailData: OrderChildType['detail'] = orderData?.child[0].detail;
  const orderStatusText: { [key: string]: OrderStatusTextEntry } = {
    ORDER_WATING: {
      statusText: langText.order_checking[lang],
      subText: langText.cancellation_unavailable[lang],
      buttonText: langText.order_in_progress[lang],
      icon: `${process.env.PUBLIC_URL}/svg/ic_clock.svg`,
      progressWidth: '10vw',
    },
    ORDER_READY: {
      statusText: langText.food_preparing[lang],
      subText: '',
      buttonText: langText.preparing[lang],
      icon: `${process.env.PUBLIC_URL}/svg/ic_clock.svg`,
      progressWidth: '25vw',
    },
    ORDER_COOKING_COMPLETE: {
      statusText: langText.preparation_complete[lang],
      subText: '',
      buttonText: langText.cooking_complete[lang],
      icon: `${process.env.PUBLIC_URL}/svg/ic_clock.svg`,
      progressWidth: '41vw',
    },
    ORDER_CANCEL: {
      statusText: langText.order_cancelled[lang],
      subText: langText.delivery_unavailable[lang],
      buttonText: `${langText.reason_label[lang]} : ${getCancelDescription(orderListData, lang)}`,
      icon: `${process.env.PUBLIC_URL}/svg/status_cancel2.svg`,
      progressWidth: '100%',
    },
    ORDER_DELIVERY_START: {
      statusText: langText.food_delivery_safe[lang],
      subText: '',
      buttonText: langText.delivery_in_progress[lang],
      icon: `${process.env.PUBLIC_URL}/svg/ic_clock.svg`,
      progressWidth: '57vw',
    },
    ORDER_DELIVERY_SUCCESS: {
      statusText: langText.item_arrived[lang],
      subText: langText.item_delivered[lang],
      buttonText: getPickupName(orderListData, lang),
      icon: `${process.env.PUBLIC_URL}/svg/ic_pickupzone.svg`,
      progressWidth: '100%',
    },
  };
  const {
    statusText = '',
    subText = '',
    buttonText = ``,
    icon = ``,
    progressWidth = '10%',
  } = orderStatusText[orderStatus] || {};

  const calculateDiscount = (orgPrice: number, discountPrice: number) => {
    if (orgPrice === discountPrice) {
      return 100;
    }
    return Math.floor(((orgPrice - discountPrice) / orgPrice) * 100);
  };

  const OrderStatus = ({ orderStatus }: any) => {
    if (
      orderStatus === 'ORDER_WATING' ||
      orderStatus === 'ORDER_READY' ||
      orderStatus === 'ORDER_DELIVERY_START' ||
      orderStatus === 'ORDER_COOKING_COMPLETE'
    ) {
      return (
        <div className="orderStatusWrap">
          <div className="loadingDots">
            <div className="dot" />
            <div className="dot" />
            <div className="dot" />
          </div>
          <h1>{statusText}</h1>
          <p>{subText !== '' && subText}</p>
          <div className="statusBox">
            <img src={icon} alt="시계아이콘" />
            <h4>{buttonText}</h4>
          </div>

          <OrderProgressBar />
        </div>
      );
    } else if (orderStatus === 'ORDER_DELIVERY_SUCCESS') {
      return (
        <div className="orderStatusWrap pickup">
          <h1>{statusText}</h1>
          <p>{subText !== '' && subText}</p>
          <div className="statusBox">
            <img src={icon} alt="픽업존 아이콘" />
            <h4>{buttonText}</h4>
          </div>
        </div>
      );
    } else if (orderStatus === 'ORDER_CANCEL') {
      return (
        <div className="orderStatusWrap cancel">
          <img src={icon} alt="취소 아이콘" />
          <h1>{statusText}</h1>
          <h4>{buttonText}</h4>
          <p>{subText !== '' && subText}</p>
        </div>
      );
    }
    return null;
  };
  const OrderProgressBar = () => {
    return (
      <div className="orderProgressWrap">
        <div className="progressBarWrap">
          <div className="progressBar" style={{ width: progressWidth }}>
            <div className="progressCircle"></div>
          </div>
        </div>
        <div className="statusText">
          <p>{langText.order_confirmation[lang]}</p>
          <p>{langText.cooking_in_progress[lang]}</p>
          <p>{langText.cooking_complete[lang]}</p>
          <p>{langText.delivery_in_progress[lang]}</p>
          <p>{langText.delivery_complete[lang]}</p>
        </div>
      </div>
    );
  };

  const OrderListDetail = () => {
    return (
      <div className="orderListWrap">
        <p className="orderTime">
          {moment(orderListData.ordered_at).format('YYYY-MM-DD HH:mm:ss')}
        </p>
        <div className="orderListContent">
          {orderListDetailData.map((prd, index: number) => (
            <div key={index} className="prdListWrap">
              <div className="prdList">
                <p className="prdIndex">{index + 1}</p>
                <h4 className="prdName">{getProductName(prd, lang)}</h4>
                {prd.product_org_price > 0 && prd.product_discount > 0 && (
                  <h4 className="prdDiscount">
                    {calculateDiscount(prd.product_org_price, prd.product_price)}%
                  </h4>
                )}
                <h4 className="prdPrice">{prd.product_price.toLocaleString()}원</h4>
              </div>
              {prd.options.length > 0 &&
                prd.options.map((option, index: number) => (
                  <div key={index} className="optionList">
                    <img src={`${process.env.PUBLIC_URL}/svg/ic_option.svg`} alt="옵션 아이콘" />
                    <p>[{getOptionTypeName(option, lang)}]</p>
                    <p>{getOptionName(option, lang)}</p>
                  </div>
                ))}
              <div className="countList">
                <h4>
                  {prd.product_quantity} {langText.count_unit[lang]}
                </h4>
              </div>
            </div>
          ))}
        </div>
        {orderListData.inquiry !== '' && (
          <div className="inquiryWrap">
            <h3>{langText.order_special_requests[lang]}</h3>
            <div className="inquiryText">{orderListData.inquiry}</div>
          </div>
        )}
      </div>
    );
  };
  return (
    <Style>
      <div className="wrap">
        <div className="title">
          <h1>{langText.knock_knock_delivery_status[lang]}</h1>
        </div>
        <div className="contentWrap">
          <div className="storeInfoWrap">
            <div className="storeInfo">
              <h3>{orderData.store_name}</h3>
              <a href={`tel:${orderListData.store_phone_number}`}>
                <img src={`${process.env.PUBLIC_URL}/svg/ic_phone.svg`} alt="전화 아이콘" />
              </a>
            </div>
            <LangSelectBox lang={lang} setLang={setLang} />
          </div>
          <OrderStatus orderStatus={orderStatus} />
          {orderStatus !== 'ORDER_CANCEL' && orderStatus !== 'ORDER_DELIVERY_SUCCESS' && (
            <button onClick={refresh} className="refreshOrderStatus">
              <img src={`${process.env.PUBLIC_URL}/svg/ic_refresh.svg`} alt="업데이트 아이콘" />
              <h3>{langText.delivery_status_update[lang]}</h3>
            </button>
          )}
          {orderStatus === 'ORDER_WATING' && (
            <div className="orderCancelButton">
              <button onClick={() => setVisibleCancel(true)}>{langText.cancel_action[lang]}</button>
            </div>
          )}
        </div>
        {orderStatus === 'ORDER_DELIVERY_SUCCESS' &&
          (orderListData.food_score === null || orderListData.delivery_score === null) && (
            <div className="contentWrap">
              <RatingContent orderData={orderData} lang={lang} refresh={refresh} />
            </div>
          )}
        <div className="contentWrap">
          <h3 className="orderListTitle">{langText.order_history[lang]}</h3>
          <OrderListDetail />
        </div>
        <div className="contentWrap">
          <div className="totalPriceWrap">
            <div className="totalPrice flexBetween">
              <h3>{langText.product_amount[lang]}</h3>
              <h3>
                {(
                  orderListData.prd_discount_amount +
                  orderListData.com_discount_amount +
                  orderListData.total_amount_incl
                ).toLocaleString()}
                원
              </h3>
            </div>
            <div className="totalPrice flexBetween">
              <h3>{langText.delivery_tip[lang]}</h3>
              <h3>{orderListData.delivery_tip.toLocaleString()}원</h3>
            </div>
            <div className="totalPrice flexBetween">
              <h3>{langText.discount_amount[lang]}</h3>
              <h3>
                -
                {(
                  orderListData.prd_discount_amount + orderListData.com_discount_amount
                ).toLocaleString()}
                원
              </h3>
            </div>
            {orderListData.prd_discount_amount > 0 && (
              <div className="discountWrap">
                <img src={`${process.env.PUBLIC_URL}/svg/ic_option.svg`} alt="옵션 아이콘" />
                <h5>{langText.product_discount[lang]}</h5>
                <h5 className="discountPrice">
                  - {orderListData.prd_discount_amount.toLocaleString()}원
                </h5>
              </div>
            )}
            {orderListData.com_discount_amount > 0 && orderListData.coupons.length > 0 && (
              <div className="discountWrap">
                <img src={`${process.env.PUBLIC_URL}/svg/ic_option.svg`} alt="옵션 아이콘" />
                <h5 className="pointColor">{langText.coupon_discount[lang]}</h5>
                {orderListData.coupons.map((data, index) => (
                  <div key={index} className="couponList">
                    <div className="circle"></div>
                    <h5 className="pointColor">{data.coupon_name}</h5>
                    <h5 className="discountPrice pointColor">
                      - {data.com_discount_amount.toLocaleString()}원
                    </h5>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
        <div className="contentWrap">
          <div className="flexBetween">
            <h3>{langText.payment_amount[lang]}</h3>
            <h2>{orderListData.total_amount_incl.toLocaleString()}원</h2>
          </div>
          <div className="footer">
            <button onClick={() => setVisibleCumtomer(true)}>
              <img src={`${process.env.PUBLIC_URL}/svg/ic_customer.svg`} alt="고객센터 아이콘" />
              <h4>{langText.customer_service[lang]}</h4>
            </button>
          </div>
        </div>
      </div>
      <CustomerServiceModal
        isOpen={visibleCumtomer}
        onCancel={() => setVisibleCumtomer(false)}
        lang={lang}
      />
    </Style>
  );
};

export default OrderQrStaus;

export const Style = styled.div`
  .flexBetween {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  h1 {
    font-size: 20px;
    font-weight: 700;
    color: #555;
  }
  h2 {
    font-size: 24px;
    font-weight: 600;
    color: #737373;
  }
  h3 {
    font-size: 18px;
    font-weight: 600;
    color: #555555;
  }
  h4 {
    font-size: 16px;
    font-weight: 600;
    color: #737373;
  }
  h5 {
    font-size: 12px;
    font-weight: 500;
    color: #737373;
  }
  p {
    font-size: 12px;
    font-weight: 300;
    color: #737373;
  }

  .wrap {
    width: 100%;
    background: #f7f7f7;
  }
  .title {
    padding: 18px 0;
    text-align: center;
    background: #ecf5f3;

    h1 {
      font-family: 'JalnanGothic';
      font-size: 16px;
      font-weight: 400;
      color: #4dd2ae;
    }
  }

  /* contentWrap */
  .contentWrap {
    padding: 20px 3vw;
    margin-bottom: 3px;
    background: #fff;
  }
  /* storeInfoWrap */
  .storeInfoWrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .storeInfo {
    display: flex;
    align-items: center;
    gap: 6px;
  }

  /* orderStatusWrap */
  .orderStatusWrap {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin-top: 18px;
    padding: 17px 14px;
    border: 1px solid #4dd2ae;
    border-radius: 20px;

    h1 {
      margin-bottom: 10px;
      font-size: 20px;
      font-weight: 700;
      color: #555;
      text-align: center;
    }
    h4 {
      font-weight: 500;
      color: #4dd2ae;
    }
    .statusBox {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 6px;
      margin-top: 20px;
      padding: 6px 16px;
      border: 1px solid #4dd2ae;
      border-radius: 30px;
    }
    p {
      line-height: 16px;
      white-space: pre;
      text-align: center;
    }
  }
  .orderStatusWrap.pickup {
    padding: 40px 14px;
    .statusBox {
      border: none;

      h4 {
        font-size: 28px;
        font-weight: 600;
        color: #40977f;
        text-align: center;
        line-height: 34px;
      }
    }
  }
  .orderStatusWrap.cancel {
    padding: 26px 14px;
    border: 1px solid #ff4a4a;

    h1 {
      margin: 0;
      padding: 21px 0;
    }
    h4 {
      margin-bottom: 15px;
      padding: 0;
      font-size: 20px;
      font-weight: 600;
      color: #ff4a4a;
    }
  }
  .refreshOrderStatus {
    width: 100%;
    margin: 18px 0;
    padding: 10px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #4dd2ae;
    color: #fff;
    border-radius: 50px;
    gap: 20px;

    h3 {
      color: #fff;
    }
  }
  .orderCancelButton {
    width: 100%;
    text-align: center;
    button {
      font-size: 16px;
      font-weight: 600;
      color: #a7a7a7;
      text-align: center;
      text-decoration: underline;
      text-underline-offset: 8px;
    }
  }

  /* orderListWrap */
  .orderListWrap {
    margin-top: 13px;

    .orderTime {
      text-align: right;
      font-size: 12px;
      font-weight: 400;
      color: #a7a7a7;
    }
  }
  .orderListContent {
    .prdListWrap {
      padding: 15px 0;
      border-top: 1px solid #e5e5e5;
      gap: 50px;
    }
    .prdListWrap:first-child {
      border-top: none;
    }
    .prdList {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      gap: 11px;

      .prdIndex {
        padding: 0px 6px;
        font-size: 12px;
        font-weight: 400;
        color: #cecece;
        border: 1px solid #cecece;
        border-radius: 4px;
      }
      .prdName {
        max-width: 80%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-size: 14px;
        font-weight: 500;
        color: #737373;
      }
      .prdDiscount {
        font-size: 14px;
        font-weight: 600;
        color: #ff6262;
      }
      .prdPrice {
        margin-left: auto;
        font-weight: 500;
      }
    }
    .optionList {
      display: flex;
      align-items: center;
      gap: 3px;
      margin-top: 10px;
      margin-left: 10%;
    }
    .countList {
      margin-top: 10px;
      text-align: right;
    }
  }
  .orderListTitle {
    text-align: center;
  }
  .inquiryWrap {
    margin-top: 15px;

    .inquiryText {
      margin-top: 10px;
      padding: 11px;
      font-size: 14px;
      font-weight: 400;
      color: #979797;
      background: #f7f7f7;
      border: 1px solid #e5e5e5;
      border-radius: 5px;
    }
  }
  /* totalPrice */
  .totalPrice {
    margin-top: 12px;
    h3 {
      font-weight: 500;
      color: #737373;
    }
  }

  /* discountWrap */
  .discountWrap,
  .couponList {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 6px;
  }
  .discountWrap {
    margin-top: 4px;
  }
  .pointColor {
    color: #4dd2ae;
  }
  .discountPrice {
    margin-left: auto;
  }
  .circle {
    width: 4px;
    height: 4px;
    background: #4dd2ae;
    border-radius: 50%;
  }

  .loadingDots {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 30px;
    gap: 24px;

    @keyframes bounce {
      20%,
      50%,
      80%,
      100% {
        transform: scale(1);
      }
      40% {
        transform: scale(1.5);
      }
    }
    .dot {
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background-color: #4dd2ae;
      margin: 12px 0;
      animation: bounce 2s infinite;
    }
    .dot:nth-child(2) {
      animation-delay: 0.5s;
    }
    .dot:nth-child(3) {
      animation-delay: 1s;
    }
  }

  /* orderProgressWrap */
  .orderProgressWrap {
    margin-top: 19px;
  }
  .progressBarWrap {
    width: 100%;
    min-width: 80vw;
    height: 8px;
    background: #cfcfcf;
    border-radius: 30px;
  }
  .statusText {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 6px;
    gap: 4px;

    p {
      flex: 1;
      max-width: 20%;
      white-space:pre-line;
    }
  }
  .progressBar {
    height: 100%;
    background-color: #6dd9b8;
    transition: width 0.4s ease;
    border-radius: 30px;
    position: relative;
  }
  .progressCircle {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #40977f;
    position: absolute;
    right: 0;
  }

  /* footer */
  .footer {
    padding: 30px 0 10px 0;
    button {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 10px;
      border: 1px solid #cecece;
      border-radius: 5px;
    }
    h4 {
      padding: 13px 0;
      font-size: 16px;
      font-weight: 600;
      color: #a7a7a7;
    }
  }
`;
